module.exports = __webpack_public_path__ + "media/images/tour/m/ko-a6d94f2307ce4848d283966354340d36.png";